// 此文件配置 Sentry 在客户端的初始化。
// 这里添加的配置将在用户在浏览器中加载页面时使用。
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"rYOHCFyUqRVlR_14s5wEK"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  //版本号
  release: document.querySelector('meta[name="commit_sha"]')?.getAttribute('content') || 'unknown',

  // 在生产环境中调整此值，或使用 tracesSampler 进行更精细的控制
  tracesSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 0.1 : 1,

  // 将此选项设置为 true 将在设置 Sentry 时在控制台打印有用的信息。
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // 这将采样率设置为 10%。在开发环境中你可能希望将其设置为 100%，
  // 而在生产环境中使用较低的采样率
  replaysSessionSampleRate: 0.1,

  // 过滤不需要上报的错误
  beforeSend(event) {
    // 排除各种形式的 Hydration Error
    const errorMessage = event.exception?.values?.[0]?.value || ''
    const errorType = event.exception?.values?.[0]?.type || ''

    // 检查错误消息中是否包含水合相关关键词
    const hydrationKeywords = [
      'Hydration',
      'hydration',
      'Text content does not match server-rendered HTML',
      'Hydration failed because the initial UI does not match',
      'Expected server HTML to contain a matching',
      'The server could not finish this Suspense boundary',
      'There was an error while hydrating',
      'Minified React error',
    ]

    const isHydrationError = hydrationKeywords.some((keyword) => errorMessage.includes(keyword))

    if (isHydrationError) {
      console.log('Sentry: 过滤水合错误:', errorMessage)
      return null
    }

    // 通过错误名称过滤
    if (event.tags?.errorName === 'Hydration Error') {
      return null
    }

    // 检查堆栈信息中是否包含水合相关内容
    const stackTrace = event.exception?.values?.[0]?.stacktrace?.frames
    if (stackTrace) {
      const hasHydrationInStack = stackTrace.some(
        (frame) =>
          frame.function?.includes('hydrate') ||
          (frame.filename?.includes('react-dom') && frame.function?.includes('render'))
      )
      if (hasHydrationInStack && errorType === 'Error') {
        console.log('Sentry: 通过堆栈过滤水合错误')
        return null
      }
    }

    return event
  },

  // 如果你不打算使用 Sentry Session Replay 功能，可以删除此选项：
  integrations: [
    Sentry.replayIntegration({
      // 其他 Replay 配置放在这里，例如：
      maskAllText: false,
      blockAllMedia: true,
      // 屏蔽所有输入框内容
      maskAllInputs: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? true : false,
    }),
  ],
  _experiments: {
    enableLongTask: true,
  },
})

// 从 localStorage 获取设备 ID 并添加到 Sentry 上下文
try {
  const deviceId = localStorage.getItem('fingerprint_device_id_v1')
  const userInfo = localStorage.getItem('userInfo')
  let userId = ''

  if (userInfo) {
    try {
      const user = JSON.parse(userInfo)
      userId = user.fid || ''
    } catch (e) {
      console.warn('无法解析 userInfo:', e)
    }
  }

  if (deviceId || userId) {
    // 设置设备信息到上下文
    Sentry.setContext('extra', {
      deviceId,
      userId,
    })
  }
} catch (error) {
  console.warn('无法从 localStorage 获取设备 ID:', error)
}
